import { EmploymentCertificateWarningInput } from "@/types/questionnaire";

const hasAnyAttachment = (value?: unknown) =>
  Array.isArray(value) && value.length > 0;

export const getEmploymentCertificateWarningTranslationKey = ({
  isEmployed,
  issueDate,
  existingAttachments,
  newAttachments,
}: EmploymentCertificateWarningInput): string | null => {
  if (!isEmployed) {
    return null;
  }

  const missingDate = !issueDate;
  const missingAttachments =
    !hasAnyAttachment(existingAttachments) && !hasAnyAttachment(newAttachments);

  if (missingDate && missingAttachments) {
    return "questionnaires.form.statements.employmentCertificateAlertBoth";
  }
  if (missingDate) {
    return "questionnaires.form.statements.employmentCertificateAlertDate";
  }
  if (missingAttachments) {
    return "questionnaires.form.statements.employmentCertificateAlertAttachment";
  }

  return null;
};
